import { WidgetCountryUsageSummaryDTO } from './widget-country-usage-summary.dto';

export interface WidgetCompanyCountryUsageSummaryDTO {
  countries                : WidgetCountryUsageSummaryDTO[];
  totalSimsAmericas        : number;
  totalSimsAsia            : number;
  totalSimsEurope          : number;
  totalSimsOther           : number;
  totalSimsUnknownLocation?: number;
};

export function WidgetCompanyCountryUsageSummaryDTO_EmptyObject(): WidgetCompanyCountryUsageSummaryDTO {
  return {
    countries               : [],
    totalSimsAmericas       : 0,
    totalSimsAsia           : 0,
    totalSimsEurope         : 0,
    totalSimsOther          : 0,
    totalSimsUnknownLocation: 0
  };
};
